import { createSlice, Draft, PayloadAction } from "@reduxjs/toolkit";

interface InitialState {
  message: null | string;
  status: null | boolean;
  type: null | string;
  notificationData: null | object;
  isLoading: boolean;
}

const initialState: InitialState = {
  message: null,
  status: null,
  type: null,
  notificationData:null,
  isLoading:false
};

const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    notificationFail: (
      state: Draft<InitialState>,
      action: PayloadAction<string>
    ) => ({
      ...state,
      status: false,
      message: action.payload,
    }),
    notificationSuccess: (
      state: Draft<InitialState>,
      action: PayloadAction<string>
    ) => ({
      ...state,
      status: true,
      message: action.payload,
    }),
    notificationWarning: (
      state: Draft<InitialState>,
      action: PayloadAction<string>
    ) => ({
      ...state,
      status: true,
      message: action.payload,
      type: "warning",
    }),
    notificationClear: (state: Draft<InitialState>) => ({
      ...state,
      message: null,
      status: null,
      type: null,
    }),
    notificationData: (state: Draft<InitialState>, action: PayloadAction<any>) => ({
      ...state,
      notificationData: action.payload,
    }),
    setLoader: (
      state: Draft<InitialState>,
      action: PayloadAction<any>
    ) => ({
      ...state,
      isLoading: action.payload,
    })
  },
});

export const {
  notificationFail,
  notificationSuccess,
  notificationClear,
  notificationWarning,
  notificationData,
  setLoader
} = notificationSlice.actions;

export default notificationSlice.reducer;
